var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7077 25.3638C19.726 25.3638 25.4155 19.6859 25.4155 12.6819C25.4155 5.67789 19.726 0 12.7077 0C5.68945 0 0 5.67789 0 12.6819C0 19.6859 5.68945 25.3638 12.7077 25.3638Z",
    fill: "#0070C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M20.6713 17.7549C22.5428 17.7549 24.06 16.2408 24.06 14.3731C24.06 12.5053 22.5428 10.9912 20.6713 10.9912C18.7997 10.9912 17.2825 12.5053 17.2825 14.3731C17.2825 16.2408 18.7997 17.7549 20.6713 17.7549Z",
    fill: "#407DBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M4.74426 17.7549C6.6158 17.7549 8.13299 16.2408 8.13299 14.3731C8.13299 12.5053 6.6158 10.9912 4.74426 10.9912C2.87272 10.9912 1.35553 12.5053 1.35553 14.3731C1.35553 16.2408 2.87272 17.7549 4.74426 17.7549Z",
    fill: "#407DBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.045 16.1906C14.6139 18.6001 10.8015 18.5578 7.37045 16.1906C6.94686 15.8946 6.60799 16.4019 6.86214 16.8669C7.92112 18.5578 9.99672 20.1219 12.7077 20.1219C15.4187 20.1219 17.4943 18.6001 18.5533 16.8669C18.8074 16.4019 18.4685 15.8946 18.045 16.1906Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2251 10.526C10.4203 8.37009 9.23427 7.271 8.04821 7.271C6.86216 7.271 5.6761 8.37009 4.87128 10.526C4.78656 10.7374 5.21015 11.1178 5.42195 10.9065C6.18441 10.1033 7.11631 9.76511 8.04821 9.76511C8.98011 9.76511 9.91202 10.1033 10.6745 10.9065C10.9286 11.1178 11.3099 10.7374 11.2251 10.526Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5018 10.526C19.697 8.37009 18.5109 7.271 17.3249 7.271C16.1388 7.271 14.9528 8.37009 14.148 10.526C14.0632 10.7374 14.4868 11.1178 14.6986 10.9065C15.4611 10.1033 16.393 9.76511 17.3249 9.76511C18.2568 9.76511 19.1887 10.1033 19.9512 10.9065C20.1629 11.1178 20.5865 10.7374 20.5018 10.526Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSmile);
export default __webpack_public_path__ + "static/media/blue_smile.0999ad595b92d1d52cd9c4d14a2568c3.svg";
export { ForwardRef as ReactComponent };